import React from 'react';
import { observer } from 'mobx-react';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import WorksheetGrid from 'components/worksheet/worksheet_grid';
import ExerciseIndex from 'components/exercise/exercise_index';
import { AppUI } from '@seedlang/state';
import eventParamsHelper from 'utils/event_params_helper';
import withRouteParams from 'utils/with_route_params';

@observer
class VideoWorksheetIndex extends React.Component {
  componentDidMount() {
    AppUI.createEvent('memrev - view videos', eventParamsHelper());
  }

  onToggleExerciseView = (value) => {
    AppUI.cookieStore.set('showExerciseView', value === 'exercises');
  }

  render() {
    return (
      <>
        {
          !AppUI.cookieStore.showExerciseView &&
            <WorksheetGrid
              showFilters
              useGridLayout={false}
              defaultWorksheetFilter={{youtube_url: true, podcast_episode_id: false}}
              showExerciseView={AppUI.cookieStore.showExerciseView ?? false}
              onToggleExerciseView={this.onToggleExerciseView}
              {...this.props}
            />
        }
        {
          AppUI.cookieStore.showExerciseView &&
            <ExerciseIndex
              showExerciseView={AppUI.cookieStore.showExerciseView}
              onToggleExerciseView={this.onToggleExerciseView}
              {...this.props}
            />
        }
      </>
    );
  }
}

export default withRouteParams(ErrorBoundary(VideoWorksheetIndex));
